import { render, staticRenderFns } from "./book-manag.vue?vue&type=template&id=54912bd8&"
import script from "./book-manag.vue?vue&type=script&lang=js&"
export * from "./book-manag.vue?vue&type=script&lang=js&"
import style0 from "./book-manag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports